import { render, staticRenderFns } from "./giftpackageEn.vue?vue&type=template&id=5f821b66&scoped=true&"
import script from "./giftpackageEn.vue?vue&type=script&lang=js&"
export * from "./giftpackageEn.vue?vue&type=script&lang=js&"
import style0 from "./giftpackageEn.vue?vue&type=style&index=0&id=5f821b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f821b66",
  null
  
)

export default component.exports